/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphsWithClientsDto } from '../../models/submissions-graphs-with-clients-dto';

export interface FactorFilteredSubmissionsWithClientsGet$Params {
  fromDate?: string;
  toDate?: string;
  aggregationType?: string;
  idType?: string;
}

export function factorFilteredSubmissionsWithClientsGet(http: HttpClient, rootUrl: string, params?: FactorFilteredSubmissionsWithClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>> {
  const rb = new RequestBuilder(rootUrl, factorFilteredSubmissionsWithClientsGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('aggregationType', params.aggregationType, {});
    rb.query('idType', params.idType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphsWithClientsDto>>;
    })
  );
}

factorFilteredSubmissionsWithClientsGet.PATH = '/Factor/filtered-submissions-with-clients';
